import { axiosSubstanceInstance } from "../AxiosConfiguration";

/**
 * Default Language (Settings > Voice & Language), through core-lambda's menu API.
 *
 * The node is `voice_language.language`: its `value` is the language Aris converses in
 * (stored in English, lower case: "english", "spanish"), `subtitle` its label, and
 * `options` what the member may choose — English, plus their own language when one was
 * set in a conversation (e.g. Activation). Writing it is the same generic menu write the
 * apps use; aris-ai reads the same record on the next conversation (plan 46 #8).
 */
const NODE = "voice_language.language";

const unwrap = (res) => res?.data?.payload ?? res?.data ?? null;

export const getConversationLanguage = async () => {
  const res = await axiosSubstanceInstance.get(`/api/v4/menu/${NODE}`);
  const node = unwrap(res) || {};
  return {
    value: node.value || "english",
    label: node.subtitle || "English",
    options: Array.isArray(node.options) ? node.options : [],
  };
};

export const setConversationLanguage = async (value) => {
  await axiosSubstanceInstance.put(`/api/v4/menu/values/${NODE}`, { value });
};
